var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"name":"_externalForm","action":_vm.action,"method":"POST","target":_vm.target}},_vm._l((_vm.mergeParams),function(param){return _c('input',{key:param.name,attrs:{"name":param.name},domProps:{"value":param.value}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }